import Button from "@web-ui/components/Button";
import ListRow from "@web-ui/components/ListRow";
import type { AuditEntry, EntityType } from "@/api/admin";
import { relative } from "@/lib/format";
import { describeActivity } from "@/publishing/changes";
import type { Pack } from "@/vocabulary/vocabulary";

/** The team's recent activity, from the audit log, in words. */
export function RecentActivity({ audit, pack, labelOf, historyHref }: { audit: AuditEntry[] | null; pack: Pack; labelOf: (type: EntityType, id: string) => string | undefined; historyHref: string }) {
  return (
    <section className="card flex flex-col gap-3" aria-labelledby="recent">
      <div className="flex items-center gap-3">
        <h2 id="recent" className="me-auto text-sub-title-1 ps-card-inset">Recent activity</h2>
        <Button as="a" variant="ghost" size="sm" href={historyHref}>See all</Button>
      </div>
      {!audit ? <p className="p-4 text-body-2 text-t-secondary" aria-busy="true">Loading…</p> : (
        <div className="flex flex-col">
          {audit.filter((e) => e.action !== "session.sign_in").slice(0, 6).map((e) => (
            <ListRow key={e.id} title={describeActivity(e, pack, labelOf)} meta={<span className="text-caption text-t-tertiary">{relative(e.at)}</span>} />
          ))}
          {audit.length === 0 ? <p className="p-4 text-body-2 text-t-secondary">No activity yet. What the team does shows here.</p> : null}
        </div>
      )}
    </section>
  );
}
